<template>
  <div class="inspection-item-manage">
    <el-tabs v-model="activeTab" type="card">
      <el-tab-pane label="检测项目管理" name="inspection-item">
        <InspectionItemTab />
      </el-tab-pane>
      <el-tab-pane label="瑕疵图片管理" name="defect-image">
        <DefectImageTab />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import InspectionItemTab from './inspection/InspectionItemTab.vue'
import DefectImageTab from './inspection/DefectImageTab.vue'

export default {
  name: 'InspectionItemManage',
  components: {
    InspectionItemTab,
    DefectImageTab
  },
  data() {
    return {
      activeTab: 'inspection-item'
    }
  }
}
</script>

<style scoped>
.inspection-item-manage {
  padding: 20px;
}
</style> 